const baseColumnDefs = [
  {
    headerName: 'SecurityId',
    field: 'securityId',
    width: 100,
  },
  {
    headerName: 'Exchange',
    field: 'exchangeCode',
    width: 160,
    tooltipField: 'exchangeCode',
  },
  { headerName: 'Asset Class', field: 'assetClass', width: 80 },
  { headerName: 'Inst Class', field: 'instrumentClass', width: 80 },
  {
    headerName: 'ISIN',
    field: 'isin',
    width: 110,
  },
  {
    headerName: 'BB_TCM',
    field: 'ticker',
    width: 180,
    tooltipField: 'ticker',
  },
  {
    headerName: 'Desc',
    field: 'securityDesc',
    width: 200,
    tooltipField: 'securityDesc',
  },
  {
    headerName: 'Underlying BB_TCM',
    field: 'underlyingSecurity.ticker',
    width: 140,
    tooltipField: 'underlyingSecurity.ticker',
  },
  {
    headerName: 'Underlying ISIN',
    field: 'underlyingSecurity.isin',
    width: 110,
    tooltipField: 'underlyingSecurity.isin',
  },
  {
    headerName: 'Underlying Code',
    field: 'underlyingSecurity.securityCode',
    width: 120,
    tooltipField: 'underlyingSecurity.securityCode',
  },
  {
    headerName: 'Price Multiplier',
    field: 'pricingMultiplier',
    width: 110,
  },
  {
    headerName: 'Contract Size',
    field: 'contractSize',
    width: 110,
  },
  { headerName: 'Pnl Currency', field: 'pnlCcyCode', width: 100 },
  {
    headerName: 'Identifiers',
    field: 'identifiers',
    width: 80,
    filter: false,
    pinned: 'right',
    cellRenderer: 'AgEditCellRenderer',
    cellRendererParams: {
      editButton: 'Identifiers',
    },
  },
  {
    headerName: 'Action',
    field: 'edit',
    width: 80,
    filter: false,
    pinned: 'right',
    cellRenderer: 'AgEditCellRenderer',
    cellRendererParams: {
      editButton: 'Edit',
    },
  },
]

const buildFutureOptionColumnDefs = ({ onIdentifiers, onEdit }) =>
  baseColumnDefs.map((col) => {
    if (col.field === 'identifiers') {
      return {
        ...col,
        cellRendererParams: {
          ...col.cellRendererParams,
          showEditModal: onIdentifiers,
        },
      }
    }
    if (col.field === 'edit') {
      return {
        ...col,
        cellRendererParams: {
          ...col.cellRendererParams,
          showEditModal: onEdit,
        },
      }
    }
    return col
  })

export { baseColumnDefs, buildFutureOptionColumnDefs }
